import styled from 'styled-components';

import Text from 'components/_core/Text';

export const StepName = styled(Text).attrs({
  fontWeight: 'weight-500',
  size: 'lg',
  variant: 'primary',
})`
  margin-top: ${({ theme }) => theme.spacings.abs32}px;
  display: block;
`;

export const InfoText = styled(Text)`
  text-align: center;
  margin: 0 ${({ theme }) => theme.spacings.abs64}px;
`;

export const BulletDivider = styled.div`
  width: ${({ theme }) => theme.spacings.abs4}px;
  height: ${({ theme }) => theme.spacings.abs4}px;
  border-radius: 50%;
  margin: ${({ theme }) => theme.spacings.abs16}px;
  background: ${({ theme }) => theme.colors.grey(-2)};
`;

export const AppPreviewNotificationWrapper = styled.div`
  padding: ${({ theme }) => theme.spacings.abs8}px 0
    ${({ theme }) => theme.spacings.abs32}px 0;
`;
